import { render, staticRenderFns } from "./CompanyProductOrderList.vue?vue&type=template&id=3f973904&"
import script from "./CompanyProductOrderList.vue?vue&type=script&lang=js&"
export * from "./CompanyProductOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports